import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, defineMessages } from 'react-intl'
import { Button, ConfettiTarget, Text, Page } from 'src/Components'
import { useFormatMessage } from 'src/providers/intl'
import panelStyles from 'src/Components/shared/Panel/Panel.module.scss'
import confirmUPBGifSource from '../unpaid-balance-confirm.gif'

import styles from './ShowPaidExtraConfirmPanel.module.scss'

const propTypes = {
  onClickBack: PropTypes.func,
  saved: PropTypes.bool,
}

const messages = defineMessages({
  gifAlt: {
    id: 'Homeowner.interest.paidExtra.gif',
    defaultMessage: "You're cutting down cost",
  },
})

const ShowPaidExtraConfirmPanel = ({ onClickBack, saved }) => {
  const intlFormat = useFormatMessage()

  return (
    <Page>
      <Page.Body className={styles.body}>
        <ConfettiTarget
          className={styles.confetti}
          numberOfPieces={150}
          go={saved}
        >
          <div className={styles.infoWrapper}>
            <img
              className={styles.image}
              src={confirmUPBGifSource}
              alt={intlFormat(messages.gifAlt)}
            />
            <Text
              size='xxl'
              align='center'
              variant='neutralCool'
              variantCount='900'
              className={styles.header}
            >
              <FormattedMessage
                id='Homeowner.interest.paidExtra.confirmHeader'
                defaultMessage='Congrats!'
              />
            </Text>
            <div className={styles.textContentBody}>
              <Text
                size='m'
                align='center'
                variant='neutralCool'
                variantCount='700'
              >
                <FormattedMessage
                  id='Homeowner.interest.paidExtra.confirmDescription'
                  defaultMessage="You're cutting down interest cost and building wealth. That's worth celebrating!"
                />
              </Text>
            </div>
          </div>
          <div className={styles.flexFill} />
          <div className={panelStyles.submitWrap}>
            <Button fullWidth onClick={onClickBack}>
              <FormattedMessage
                id='Homeowner.interest.paidExtra.returnButton'
                defaultMessage='Return to dashboard'
              />
            </Button>
          </div>
        </ConfettiTarget>
      </Page.Body>
    </Page>
  )
}

ShowPaidExtraConfirmPanel.propTypes = propTypes

export default ShowPaidExtraConfirmPanel
